/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react'
import { Box, Grid } from '@mui/material';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import HashicorpUsers from '../views/hashicorp/HashicorpUsers';
import UserSecret from '../views/hashicorp/UserSecret';
import HashicorpUserCreation from '../views/hashicorp/hashicorpUserCreation';

const ManageHashicorpPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Hashicorp Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6}>
                        <HashicorpUserCreation />
                        <UserSecret />

                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <HashicorpUsers />
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default ManageHashicorpPage;